import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import account from './modules/account';
import adventures from './modules/adventures';
import applications from './modules/applications';
import backupCare from './modules/backupCare';
import interviewRequest from './modules/interviewRequest';
import job from './modules/job';
import navigation from './modules/navigation/index';
import sitterOnboarding from './modules/sitterOnboarding';
import { clearCache } from './cache';

Vue.use(Vuex);

clearCache();

const vuexSessionStorage = new VuexPersist({
  key: 'vuex', // display key in the browser session
  storage: window.sessionStorage,
});

const store = new Vuex.Store({
  plugins: [vuexSessionStorage.plugin],
  modules: {
    account,
    adventures,
    applications,
    backupCare,
    interviewRequest,
    job,
    navigation,
    sitterOnboarding,
  },
});

export default store;
